import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import MainLayout from "../layout/MainLayout";
import { motion } from "framer-motion";
import remarkGfm from "remark-gfm";
import matter from "gray-matter";
import { Calendar, Tag } from "lucide-react";

export const Post = () => {
  const { slug } = useParams();
  const [content, setContent] = useState("");
  const [frontmatter, setFrontmatter] = useState({});

  useEffect(() => {
    import(`../blog/${slug}.md`)
      .then((res) => fetch(res.default))
      .then((res) => res.text())
      .then((text) => {
        const { data, content } = matter(text);
        setFrontmatter(data);
        setContent(content);
      })
      .catch((err) => console.error("Error loading post:", err));
  }, [slug]);

  return (
    <MainLayout>
      {/* Hero Section */}
      {frontmatter.cover && (
        <section
          className="relative h-[45vh] rounded-3xl mx-4 sm:mx-10 mt-6 overflow-hidden shadow-xl flex items-center justify-center bg-cover bg-center"
          style={{ backgroundImage: `url(${frontmatter.cover})` }}
        >
          <div className="absolute inset-0 bg-black/50 z-0" />
          <div className="relative z-10 text-center text-white max-w-3xl px-6">
            {frontmatter.category && (
              <span className="inline-flex items-center gap-1 text-sm font-medium bg-teal-600 rounded-full px-3 py-1 mb-3">
                <Tag size={14} /> {frontmatter.category}
              </span>
            )}
            <motion.h1
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 }}
              className="text-3xl sm:text-5xl font-bold mb-2 just-me-again-down-here-regular"
            >
              {frontmatter.title}
            </motion.h1>
            {frontmatter.date && (
              <div className="flex justify-center items-center gap-2 text-white/80 text-sm mt-2">
                <Calendar size={16} />
                {new Date(frontmatter.date).toLocaleDateString()}
              </div>
            )}
          </div>
        </section>
      )}

      <section className="max-w-4xl mx-auto px-6 py-16">
        <Link
          to="/blog"
          className="text-teal-600 hover:underline mb-6 inline-block"
        >
          ← Back to Blog
        </Link>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <article className="prose dark:prose-invert max-w-none prose-h1:text-4xl prose-h2:text-2xl prose-p:text-lg">
            <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
          </article>
        </motion.div>
      </section>
    </MainLayout>
  );
};

export default Post;
